/**
 * Text order a person expects: the numbers inside a label count as numbers.
 *
 * A plain `localeCompare` reads "P10" as "P", "1", "0" and puts it before
 * "P2" — a Priority column sorted P1, P10, P2 (QA B03-08, staging 2026-10-27).
 * Every component that orders labels goes through this one comparison.
 */
const collator = typeof Intl !== 'undefined'
  ? new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
  : null;

export function compareText(a, b) {
  const x = String(a ?? '');
  const y = String(b ?? '');
  return collator ? collator.compare(x, y) : x.localeCompare(y);
}
